import { NgModule } from '@angular/core';
import { LayoutComponent } from '@sbd-doug-frontend/app/layout/layout.component';
import { EmptyLayoutModule } from '@sbd-doug-frontend/app/layout/layouts/empty/empty.module';
// import { CenteredLayoutModule } from '@sbd-doug-frontend/app/layout/layouts/horizontal/centered/centered.module';
// import { EnterpriseLayoutModule } from '@sbd-doug-frontend/app/layout/layouts/horizontal/enterprise/enterprise.module';
// import { MaterialLayoutModule } from '@sbd-doug-frontend/app/layout/layouts/horizontal/material/material.module';
import { ModernLayoutModule } from '@sbd-doug-frontend/app/layout/layouts/horizontal/modern/modern.module';
import { ClassicLayoutModule } from '@sbd-doug-frontend/app/layout/layouts/vertical/classic/classic.module';
// import { ClassyLayoutModule } from '@sbd-doug-frontend/app/layout/layouts/vertical/classy/classy.module';
// import { CompactLayoutModule } from '@sbd-doug-frontend/app/layout/layouts/vertical/compact/compact.module';
// import { DenseLayoutModule } from '@sbd-doug-frontend/app/layout/layouts/vertical/dense/dense.module';
// import { FuturisticLayoutModule } from '@sbd-doug-frontend/app/layout/layouts/vertical/futuristic/futuristic.module';
import { ThinLayoutModule } from '@sbd-doug-frontend/app/layout/layouts/vertical/thin/thin.module';
import { SettingsModule } from '@sbd-doug-frontend/app/layout/common/settings/settings.module';
import { SharedModule } from '@sbd-doug-frontend/app/shared/shared.module';

const layoutModules = [
    // Empty
    EmptyLayoutModule,

    // Horizontal navigation
    // CenteredLayoutModule,
    // EnterpriseLayoutModule,
    // MaterialLayoutModule,
    ModernLayoutModule,

    // Vertical navigation
    ClassicLayoutModule,
    // ClassyLayoutModule,
    // CompactLayoutModule,
    // DenseLayoutModule,
    // FuturisticLayoutModule,
    ThinLayoutModule
];

@NgModule({
    declarations: [
        LayoutComponent
    ],
    imports     : [
        SharedModule,
        SettingsModule,
        ...layoutModules
    ],
    exports     : [
        LayoutComponent,
        ...layoutModules
    ]
})
export class LayoutModule
{
}
